import styled from 'styled-components'

const StyledTable = styled('div')`
  width: 100%;
`

export { StyledTable }
